export default __webpack_public_path__ + "static/AA081210_Citation_680-0093-01a_540x358-b7baf1aef82f113c3254846589704d81.jpg";